export default {
    AppName: "Timbrely",
};